const productImage = "https://media.onedash.com/"

module.exports = productImage;